var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
// @ts-ignore
import { AfyPlanBenefitsInfo, AlertAFY, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useGetSteps } from "../../utils/getSteps";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
import showToast from "../../services/toast";
import { HeaderTitlePage } from "../../components/resources/headerTitlePage/headerTitlePage";
import { useSummaryFilters } from "../addBusiness/hooks";
import { findParamInLocalStorage } from "../../utils/getAnyDataLocalStorge";
import { getFlagValue } from "ah_utility/fnxUtils";
import { isVidaActiva } from "../../utils/isVidaActiva";
import { formatRD } from "../../utils/getPrice";
import { useDataPerson, useGetPaymentMode, useGetPerson, usePaymentModeData, usePremiumCalculate, } from "./hooks";
import { useGetCatalogGender } from "./hooks/callApis/callApiCatalogGender";
import { usePlanData } from "./hooks/usePlanData";
import { useLocation } from "react-router-dom";
import { useGetInformationSteps } from "ah_utility/workflow";
import useCompleteStepCalculatePremium from "./hooks/useCompleteStep";
import { useErrorHandling } from "./hooks/useErrorHandling";
import { premiumCalculatePostClearData } from "../../store/premiumCalculate/actions";
import { useDispatch } from "react-redux";
import { getCatalogBusinessClearData } from "../../store/catalog/actions";
import { personClearData } from "../../store/person/actions";
import { alertPROPS } from "./constants/calculate.constants";
export var CalculatePremium = function () {
    var _a, _b;
    var dispatch = useDispatch();
    var steps = useGetSteps();
    var _c = useState(""), paymentMode = _c[0], setPaymentMode = _c[1];
    var _d = useState(""), paymentModeName = _d[0], setPaymentModeName = _d[1];
    var _e = useState("0"), annualPremium = _e[0], setAnnualPremium = _e[1];
    var _f = useState(0), coverageAmount = _f[0], setCoverageAmount = _f[1];
    var filters = useSummaryFilters().filters;
    var pathname = useLocation().pathname;
    var pathLocation = "/" + pathname.split("/")[1];
    var Plan = React.useState(findParamInLocalStorage("Plan"))[0];
    var _g = useState(false), openAlert = _g[0], setOpenAlert = _g[1];
    var _h = useState(""), alertMessage = _h[0], setAlertMessage = _h[1];
    var _j = useState(true), disableNextButton = _j[0], setDisableNextButton = _j[1];
    var planData = Plan === null || Plan === void 0 ? void 0 : Plan["0"];
    var planName = (_a = planData === null || planData === void 0 ? void 0 : planData.name) !== null && _a !== void 0 ? _a : "";
    var listTipoCuenta = [{ id: "1", name: "Tarjetas", value: "TARJETAS" }];
    var projectId = React.useState(findParamInLocalStorage("projectId"))[0];
    var personData = React.useState(findParamInLocalStorage("personData"))[0];
    var _k = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _k[0], setSeeToast = _k[1];
    var cardsOnlyLimit = getFlagValue("afy-cards-only-higher-limit");
    var onlyCreditCard = getFlagValue("afy-validate-only-credit-card");
    var isVidaActivaFlow = isVidaActiva();
    // CALL APIS
    var _l = useGetPaymentMode(true, projectId), responsePaymentMode = _l.responsePaymentMode, loadingPaymentMode = _l.loadingPaymentMode, errorPaymentMode = _l.errorPaymentMode;
    var _m = useGetCatalogGender(true), responseGetCatalog = _m.responseGetCatalog, loadingGetCatalog = _m.loadingGetCatalog, errorGetCatalog = _m.errorGetCatalog;
    var _o = useGetPerson(true, personData), responsePerson = _o.responsePerson, loadingPerson = _o.loadingPerson, errorPerson = _o.errorPerson;
    // END CALL APIS
    var _p = useDataPerson(responsePerson, responseGetCatalog, cardsOnlyLimit, onlyCreditCard, isVidaActivaFlow), rawBirthDate = _p.birthDate, rawGender = _p.gender, rawCreditCardList = _p.creditCardList;
    var _q = useState(""), gender = _q[0], setGender = _q[1];
    var _r = useState(""), birthDate = _r[0], setBirthDate = _r[1];
    var _s = useState([]), creditCardList = _s[0], setCreditCardList = _s[1];
    var _t = useState(null), pendingCalculation = _t[0], setPendingCalculation = _t[1];
    useEffect(function () {
        if (rawGender)
            setGender(rawGender);
        if (rawBirthDate)
            setBirthDate(rawBirthDate);
        if (rawCreditCardList.length > 0)
            setCreditCardList(rawCreditCardList);
    }, [rawGender, rawBirthDate, rawCreditCardList]);
    useEffect(function () {
        if (pendingCalculation && gender && birthDate) {
            calculatePremium(pendingCalculation.coverage, pendingCalculation.mode);
            setPendingCalculation(null);
        }
    }, [gender, birthDate, pendingCalculation]);
    useEffect(function () {
        if (errorPerson || errorGetCatalog) {
            setPendingCalculation(null);
        }
    }, [errorPerson, errorGetCatalog]);
    var _u = usePlanData(), productCode = _u.productCode, planCode = _u.planCode;
    var _v = usePremiumCalculate(productCode, planCode, birthDate, gender), responseCalculate = _v.responseCalculate, errorCalculate = _v.errorCalculate, loadingCalculate = _v.loadingCalculate, calculatePremium = _v.calculatePremium, lastBody = _v.lastBody;
    var _w = useGetInformationSteps(pathLocation), instanceId = _w.instanceId, workFlowId = _w.workFlowId, currentStep = _w.currentStep, nextStep = _w.nextStep;
    var dataCalculation = {
        gender: gender,
        smokes: false,
        coverageAmount: coverageAmount,
        paymentMode: paymentMode,
        paymentModeName: paymentModeName,
        planCode: planCode,
    };
    var _x = useCompleteStepCalculatePremium(instanceId, workFlowId, currentStep, nextStep, setSeeToast, dataCalculation, lastBody), onClickNextStep = _x.onClickNext, loadingComplete = _x.loadingComplete, errorComplete = _x.errorComplete, handleClickPrevious = _x.handleClickPrevious;
    useErrorHandling({
        errorGetCatalog: errorGetCatalog,
        errorPerson: errorPerson,
        errorPaymentMode: errorPaymentMode,
        errorCalculate: errorCalculate,
        errorComplete: errorComplete,
        setDisableNextButton: setDisableNextButton,
        setSeeToast: setSeeToast,
    });
    useEffect(function () {
        return function () {
            dispatch(personClearData());
            dispatch(getCatalogBusinessClearData());
        };
    }, []);
    useEffect(function () {
        if ((responseCalculate === null || responseCalculate === void 0 ? void 0 : responseCalculate.annualPremium) !== undefined) {
            setAnnualPremium(String(responseCalculate.annualPremium));
            dispatch(premiumCalculatePostClearData());
        }
    }, [responseCalculate]);
    useEffect(function () {
        setDisableNextButton(Number(annualPremium) <= 0);
    }, [annualPremium]);
    var listModalidadPago = usePaymentModeData(responsePaymentMode).listModalidadPago;
    useEffect(function () {
        if (!paymentMode && listModalidadPago.length > 0) {
            var first = listModalidadPago[0];
            setPaymentMode(first.value);
            setPaymentModeName(first.name);
        }
    }, [listModalidadPago, paymentMode]);
    var coverages = ((_b = planData === null || planData === void 0 ? void 0 : planData.benefits) !== null && _b !== void 0 ? _b : []).map(function (benefit) { return ({
        id: benefit.id,
        name: benefit.description,
        value: formatRD(benefit.value),
    }); });
    var handleChangeTerminalTarjeta = function (data) {
        var _a, _b;
        setAnnualPremium("0");
        var coverage = (_a = data.montoAprobado) !== null && _a !== void 0 ? _a : "";
        var mode = data.modalidadPago;
        var isInvalid = coverage === "0" || Number(coverage) < 0;
        setOpenAlert(isInvalid);
        if (isInvalid) {
            setAlertMessage("Esta Tarjeta no aplica para el producto seleccionado");
            return;
        }
        var selected = listModalidadPago.find(function (m) { return m.value === mode || m.id === mode; });
        setPaymentMode(mode);
        setPaymentModeName((_b = selected === null || selected === void 0 ? void 0 : selected.name) !== null && _b !== void 0 ? _b : "");
        setCoverageAmount(Number(coverage));
        if (gender && birthDate) {
            calculatePremium(coverage, mode);
        }
        else {
            setPendingCalculation({ coverage: coverage, mode: mode });
        }
    };
    return (_jsxs(React.Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loadingPaymentMode ||
                    loadingPerson ||
                    loadingGetCatalog ||
                    loadingCalculate ||
                    loadingComplete, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: "Calculando..." }), _jsx(HeaderTitlePage, { titlePage: "Calcular prima", breadCrumbs: [], steps: steps }), _jsx("div", __assign({ style: { marginBottom: openAlert ? "15px" : "0" } }, { children: _jsx(AlertAFY, __assign({}, alertPROPS, { description: alertMessage, isOpen: openAlert, onClose: function () { return setOpenAlert(false); } })) })), _jsx(AfyPlanBenefitsInfo, { annualPremium: formatRD(annualPremium), coverages: coverages, listModalidadPago: listModalidadPago, listTerminalTarjeta: creditCardList, listTipoCuenta: listTipoCuenta, planName: planName, previousLabel: "Anterior", onClickPrevious: function () { return handleClickPrevious(); }, onClickNext: function () { return onClickNextStep(); }, onChangeTipoCuenta: function () { }, onChangeTerminalTarjeta: handleChangeTerminalTarjeta, filters: filters, minHeight: openAlert ? "calc(100vh - 222px)" : "calc(100vh - 155px)", nextDisabled: disableNextButton, labelTerminalTarjeta: isVidaActiva() ? "Terminal Tarjeta:" : "Terminal Tarjeta Más Límite:", labelMontoAprobado: isVidaActiva() ? "Monto aprobado (RD$):" : "Monto aprobado Más Límite (RD$):" })] }));
};
